<template>
    <div class="menu">
        <template v-if="menus.length > 0">
            <div class="item" v-for="(item, index) in menus" :key="item.id" :class="{active: activeIndex == index, has_child: item.item.length > 0}">
                <router-link class="name" v-if="item.type == 1" :to="`/detail/${item.id}`">{{item.name}}</router-link>
                <router-link class="name" v-else-if="item.type == 2" :to="`/list/${item.id}`">{{item.name}}</router-link>
                <router-link class="name" v-else-if="item.type == 3" :to="`/repair/${item.id}`">{{item.name}}</router-link>
                <router-link class="name" v-else-if="item.type == 4" :to="`/message/${item.id}`">{{item.name}}</router-link>
                <router-link class="name" v-else-if="item.type == 5" :to="`/contact/${item.id}`">{{item.name}}</router-link>
                <router-link class="name" v-else-if="item.type == 6" :to="`/photo/${item.id}`">{{item.name}}</router-link>

                <!-- <router-link class="name" v-else to="/">{{item.name}}</router-link> -->
                <div class="list" v-if="item.item.length > 0">
                    <template v-for="_item in item.item">
                        <!-- <router-link class="link" :key="_item.id" v-if="_item.type == 1" :to="`/detail/${_item.id}`">{{_item.name}}</router-link>
                        <router-link class="link" :key="_item.id" v-else-if="_item.type == 2" :to="`/list/${_item.id}`">{{_item.name}}</router-link>
                        <router-link class="link" :key="_item.id" v-else-if="_item.type == 3" :to="`/repair/${_item.id}`">{{_item.name}}</router-link>
                        <router-link class="link" :key="_item.id" v-else-if="_item.type == 4" :to="`/contact/${_item.id}`">{{_item.name}}</router-link>

                        <router-link class="link" :key="_item.id" v-else-if="_item.type == 6" :to="`/photo/${_item.id}`">{{_item.name}}</router-link> -->
                        <router-link class="link" :key="_item.id" v-if="_item.type == 7" :to="`/repair/${item.id}/detail/${_item.id}`">{{_item.name}}</router-link>
                    </template>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
import { mapState } from 'vuex';
export default {
    name: "detailMenu",
    data() {
        return {
            activeIndex: null,
        };
    },
    computed: {
        ...mapState(['menus']),
    },
    components: {
        
    },
    mounted() {
    },
    destroyed() {},
    watch: {
        'menus': {
            handler: 'getMenuName',
            immediate: true
        }
    },
    methods: {
        getMenuName(){
            for(var i = 0; i < this.menus.length; i++){
                let item = this.menus[i];
                let id;
                if(this.$route.params.id){
                    id = this.$route.params.id;
                }else if(this.$route.params.menuId){
                    id = this.$route.params.menuId;
                }
                if(id == item.id){
                    this.activeIndex = i;
                    this.$store.state.menuName = item.name;
                    break;
                }
            }
        }
    },
};
</script>

<style scoped lang="scss">
.menu{
    width: 210px;
    box-shadow: 0px 0px 10px rgba(0,0,0,.1);
    border-radius: 10px;
    overflow: hidden;
    @media only screen and (max-width: 1024px) {
        display: none;
    }
    .item{
        .name{
            display: block;
            height: 50px;
            line-height: 50px;
            padding-left: 26px;
            font-size: 16px;
            background: linear-gradient(to bottom, rgb(215,231,245), rgb(193,217,240));
            cursor: pointer;

            
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 1;
            /*! autoprefixer: off */
            -webkit-box-orient: vertical;

            &:hover{
                background: linear-gradient(to bottom, rgb(63,137,210), rgb(24,74,141));
                color: #fff;
            }
        }
        &.active{
            .name{
                padding-left: 22px;
                border-left: 4px solid #ff8432;
                color: #fff;
                background: #184a8d url('~@/assets/images/button1_03.jpg') no-repeat;
                background-position: 174px center;
                background-color: #184a8d;
                background-repeat: no-repeat;
                padding-right: 40px;
            }
            &.has_child{
                .name{
                    background-image: none;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    padding-right: 20px;
                    &::after{
                        content: "";
                        display: block;
                        width: 10px;
                        height: 10px;
                        border-bottom: 2px solid #fff;
                        border-right: 2px solid #fff;
                        transform: rotate(45deg) translate(-25%, -25%);
                    }
                }
            }
            .list{
                display: block;
            }
        }
        .list{
            display: none;
            padding: 3px 0 3px 26px;
            .link{
                display: block;
                height: 42px;
                line-height: 42px;
                background: #fff;
                font-size: 14px;
                color: #656565;
                text-align: center;
                margin-bottom: 3px;
                cursor: pointer;
                // padding: 0 10px;
                
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 1;
                /*! autoprefixer: off */
                -webkit-box-orient: vertical;
                &:last-child{
                    margin-bottom: 0;
                }
                &.active,
                &:hover{
                    background: #ff9046;
                    color: #fff;
                }
            }
        }
    }
}
</style>